const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M2.5 5.5A1.5 1.5 0 0 0 1 7v7.5A3.5 3.5 0 0 0 4.5 18h11a1.5 1.5 0 0 0 1.5-1.5V9a3.5 3.5 0 0 0-3.5-3.5h-11Zm20.5 1a.75.75 0 0 0-1.2-.6l-3.2 2.4a1.5 1.5 0 0 0-.6 1.2V14c0 .472.222.917.6 1.2l3.2 2.4A.75.75 0 0 0 23 17V6.5Z" clip-rule="evenodd"></path></svg>';
export {
  l as default
};
